// <GENERATED-CODE>
// Generated from Java using 'npm run generate:ts'

const DRILL_THROUGH_DISPLAY_MODE_TO_PERSISTENCE_KEY = {
  DROPDOWN: 'drillThrough.display.dropdown',
  DIRECT: 'drillThrough.display.direct'
} as const;

/** @see net/disy/cadenza/workbook/model/DrillThroughDisplayMode.java */
export type DrillThroughDisplayMode = keyof typeof DRILL_THROUGH_DISPLAY_MODE_TO_PERSISTENCE_KEY;

export const DrillThroughDisplayMode = {
  values: Object.keys(DRILL_THROUGH_DISPLAY_MODE_TO_PERSISTENCE_KEY) as readonly DrillThroughDisplayMode[],
  toPersistenceKey: (value: DrillThroughDisplayMode) => DRILL_THROUGH_DISPLAY_MODE_TO_PERSISTENCE_KEY[value],
  fromPersistenceKey: (persistenceKey: string) => {
    const value = DrillThroughDisplayMode.values.find(key => DRILL_THROUGH_DISPLAY_MODE_TO_PERSISTENCE_KEY[key] === persistenceKey);
    if (!value) { throw new Error(`No DrillThroughDisplayMode for key: ${persistenceKey}`); }
    return value;
  },
} as const;

// </GENERATED-CODE>
